import classes from './Bloglist.module.css';
import Blogpost from "./Blogpost";

function Bloglist(props) {
    return (
        <div className={classes.list}>
            <ul>
                {props.blogs.map((blog) =>
                    <Blogpost key={blog.id}
                              id={blog.id}
                              image={blog.image}
                              date={blog.date}
                              author={blog.author}
                              title={blog.title}
                              intro={blog.intro}
                              content={blog.content}/>)}
                <button className={classes.actions}> lees meer</button>

            </ul>

        </div>
    );
}

export default Bloglist;